// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1778":"4522bdbde7b556a1","4871":"4a1809c8f85eaf24","8208":"d90a0cbf6b584d12"}[chunkId] + ".js";
};